module.exports = __webpack_public_path__ + "static/media/empty-state-defects.746cac7e.svg";